import { Component, OnInit } from '@angular/core';
import CONFIG from '../config';
import { AuthService } from '../shared/auth.service';
import { BackendService } from '../shared/backend.service';
import { OrderByService } from '../shared/orderby.service';
import { PaginationService } from '../shared/pagination.service';
import { saveAs as importedSaveAs } from 'file-saver';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent implements OnInit {

  apiUrl:any;
  Documents:any;
  defaultSortOrder: string = '';
  currentSortOrder: string = '';
  pagenlenth: boolean = true;
  entryRangeSubscription: Subscription;
  entryRange: Array<number>;
  totalviewsubmissionsEntries: number = 0;
  totalauditrecrodsEntries: number=0 ;
  BankId:any;

  constructor(
    public backendService:BackendService,
    public authService:AuthService,
    public orderByService:OrderByService,
    public paginationService:PaginationService,


  ) { }

  ngOnInit() 
  {
    this.apiUrl=CONFIG.getDocumentsDataApiURLBase;
    this.getPageloadData();
    this.defaultSortOrder = 'documentDate';
  }

  getPageloadData()
  {
    console.log(this.authService.TransactionNo);
    if(this.authService.LoginType=='Admin')
     {
       this.BankId=this.authService.bankcodevalue;
     }
     else
     {
      this.BankId=this.authService.TaskNumber;
     }
    this.backendService.getData(`${this.apiUrl}/${this.BankId}/${this.authService.TransactionNo}`)
    .subscribe(response => { console.log(response);
      this.Documents=response['documents'];

      this.setGrid(1, this.Documents.length);
        this.entryRangeSubscription = this.paginationService.entryRange
            .subscribe(range => {
                this.entryRange = range;
                console.log("range" + this.entryRange[0], this.entryRange[1]);
                this.Documents=this.Documents.slice(this.entryRange[0], this.entryRange[1]);;
                //this.exportItems = this.datefilteredaudit;
                console.log('this.audit' + this.Documents.length);
                this.totalviewsubmissionsEntries = this.Documents.length; 
                console.log(this.Documents.length); 
                if(this.Documents==null)
                    this.totalauditrecrodsEntries=0;  
                    else
                            this.totalauditrecrodsEntries=this.Documents.length;             
            });


    })
  }
  orderBy(param, length?: number) {
    if (param !== '') {
      this.currentSortOrder = param;
    } else {
      param = this.defaultSortOrder;
    };
    let itemsToOrder = this.Documents;
    let sortingByCurrentShares = false;
    const altParam = param === this.defaultSortOrder ? undefined : this.defaultSortOrder;
    this.Documents = this.orderByService.orderByParam(param, itemsToOrder, altParam,"","documetnsdesc");
    if (length) {
      var itemsLength: number = length;
      console.log('length')
    } else {
      var itemsLength: number = itemsToOrder.length;
    }

    this.setGrid(1, itemsLength);

  }
  setGrid(start: number, length?: number) {
    let sentLen = length;

    if (length === undefined) {
      sentLen = this.Documents.length;
    }
    this.pagenlenth = false;

    this.paginationService.setGrid(start, sentLen);
  }
  DownloadFile(value,name)
  {
    console.log(value);
    

    this.backendService.downloadFile1(this.apiUrl,value,name).subscribe(blob => {

      importedSaveAs(blob, name);
    })
  }
  
 

}
